<div #videoHolder class="video-player-holder">
  <aku-overlay/>

  <img #logo
       class="logo"
       [src]="environment.bucketUrlImages + 'zweed_log_white.png'"
       alt="Company logo">

  @if (activeVideoElement() && (!activeVideoElement()!.paused || activeVideoElement()!.currentTime !== 0)) {
    <button class="skip-button" (click)="skipVideo()">
      <span>Skip</span>
      <img src="assets/icon_skip.svg" alt="skip">
    </button>
  }

  @for (video of videosToPreLoad(); track $index) {
    <video #video
           [id]="video.id"
           [class]="'video' + (configService.activeVideo?.id === video.id ? ' active' : '')"
           [controlsList]="'nodownload nofullscreen noremoteplayback'"
           playsinline
    >
      <caption></caption>
      <track
        label="English"
        kind="subtitles"
        srclang="en"
        src=""
        default/>
      <source [src]="environment.bucketUrlVideos + video.url" type="video/mp4">

      Your browser does not support the video tag.
    </video>
  }

  <img
    [class.visible]="showHome()"
    class="image"
    alt="Home menu"
    [src]="environment.bucketUrlImages + configService.homeImg">
</div>